function isObject(value) {
  return value && typeof value === 'object' && value.constructor === Object
}

export default isObject



// WEBPACK FOOTER //
// ./src/utils/isObject.js